import { ArrowDownLeft, ArrowUpRight, FileQuestion, Files, Sparkles, CheckCircle2, CircleDashed } from "lucide-react";

/** Bilagstyper (doc_type) – verdier speiler backend (services/attachments.py). */
export const DOC_TYPES = {
  inngaende_regning: { label: "Inngående regning", short: "Inngående", icon: ArrowDownLeft, className: "status-til_betaling", help: "Regning, kvittering eller faktura du skal betale/har betalt." },
  utgaende_faktura: { label: "Utgående faktura", short: "Utgående", icon: ArrowUpRight, className: "status-avtalegiro", help: "Faktura eller kreditnota virksomheten din har sendt til en kunde." },
  annet: { label: "Annet", short: "Annet", icon: Files, className: "status-avvist", help: "Kontoutskrift, avtale, brev eller annet bilag uten betaling." },
};

export const DOC_TYPE_UNKNOWN = { label: "Ikke klassifisert", short: "Ukjent", icon: FileQuestion, className: "status-avvist border-dashed" };

export const DOC_TYPE_OPTIONS = Object.entries(DOC_TYPES).map(([value, cfg]) => ({ value, ...cfg }));

/** Status: ny (ikke lest) | foreslatt (AI har foreslått) | bekreftet (du har bekreftet) */
export const ATTACHMENT_STATUS = {
  ny: { label: "Ikke lest", icon: CircleDashed, className: "status-avvist" },
  foreslatt: { label: "Foreslått", icon: Sparkles, className: "status-ma_kontrolleres" },
  bekreftet: { label: "Bekreftet", icon: CheckCircle2, className: "status-betalt" },
};

export const STATUS_TABS = [
  { value: "alle", label: "Alle" },
  { value: "ny", label: "Ikke lest" },
  { value: "foreslatt", label: "Foreslått" },
  { value: "bekreftet", label: "Bekreftet" },
];

export const ACCEPTED_EXT = [".pdf", ".png", ".jpg", ".jpeg", ".webp", ".xml"];
export const ACCEPT_ATTR = ".pdf,.png,.jpg,.jpeg,.webp,.xml,application/pdf,image/png,image/jpeg,image/webp,application/xml,text/xml";
export const MAX_FILE_MB = 15;

export const VAT_RATES = [25, 15, 12, 0];
